// extracted by mini-css-extract-plugin
module.exports = {"OuterContainer":"BundleMobileAddRibbonWrapper_OuterContainer__7oQmo","Container":"BundleMobileAddRibbonWrapper_Container__3eoxK"};